import { AcceptedFileTypes } from "@fronterahealth/frontera-ui-components";

export const FileAcceptMapping: Record<AcceptedFileTypes, string> = {
  pdf: "application/pdf",
  png: "image/png",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  amr: "audio/amr",
  mp4: "video/mp4",
  mpeg: "video/mpeg",
  mp3: "audio/mp3",
  ogg: "audio/ogg",
  flac: "audio/flac",
  wav: "audio/wav",
  webm: "video/webm",
  m4a: "audio/m4a",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xls: "application/vnd.ms-excel",
  csv: "text/csv",
  mov: "video/quicktime",
  avi: "video/x-msvideo",
  mkv: "video/x-matroska",
  wmv: "video/x-ms-wmv",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
};
